import { create } from "zustand";
import { LIST_EQUIP } from "../../Utils/constant";
import { getAll } from "../../services/service";
export const useStoreEquipement = create((set) => ({
  loading: false,
  data: [],
  count: 1,
  equipement: async (param) => {
    set({
      loading: true,
      data: [],
      count: 1,
    });

    try {
      const equipements = await getAll(LIST_EQUIP, param, "");
      set({
        loading: false,
        data: equipements.data,
        count: equipements.data.totalPages,
      });
    } catch (error) {
      set({
        loading: true,
        data: [],
        count: 1,
      });
    }
  },
}));
